import React from "react";
import { useLanguage } from "../../i18n/LanguageContext";

const IMGS = [
  // Gamba roja a la plancha
  "https://customer-assets.emergentagent.com/job_corte-tradicional/artifacts/vl4gyivz_3191ffe1-5a09-4649-a148-acec9456ae35.jpg",
  // Atún rojo de almadraba
  "https://customer-assets.emergentagent.com/job_corte-tradicional/artifacts/nlp4fm74_874fef21-90cc-4571-a0f3-8804577660c5.jpg",
  // Gambas cocidas de Huelva
  "https://customer-assets.emergentagent.com/job_corte-tradicional/artifacts/451sawbv_67abf93c-d078-4abb-a98a-b7d56241b88b.jpg",
  // Bacalao al ajillo
  "https://customer-assets.emergentagent.com/job_corte-tradicional/artifacts/vs5ybj4z_9491d4af-edd2-4f16-9d06-3fd2d9e1a1b6.jpg",
  // Almejas de Carril en salsa
  "https://customer-assets.emergentagent.com/job_corte-tradicional/artifacts/i10bou0v_35899835-3fe7-48ed-9c21-6c4dde1a368d.jpg",
  // Carrillada
  "https://customer-assets.emergentagent.com/job_corte-tradicional/artifacts/30goqe4k_4187bb32-94d5-4add-b338-415436ab4b55.jpg",
];

export default function Platos() {
  const { t } = useLanguage();
  const items = t.platos.items;

  return (
    <section
      id="platos"
      data-testid="platos-section"
      className="relative py-24 md:py-32 bg-[#1A1A1A] text-[#F9F6F0]"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-10 lg:px-16">
        <div className="max-w-3xl mb-16">
          <div className="eyebrow !text-[#E8A87C] mb-4">{t.platos.eyebrow}</div>
          <h2
            data-testid="platos-title"
            className="font-serif-display text-4xl md:text-5xl lg:text-6xl tracking-tight leading-[1.05]"
          >
            {t.platos.title}
          </h2>
          <p className="mt-6 text-[#C6C0B5] text-base md:text-lg leading-relaxed">
            {t.platos.subtitle}
          </p>
        </div>

        {/* Bento grid */}
        <div className="grid grid-cols-1 md:grid-cols-6 gap-4 md:gap-6">
          {items.map((dish, idx) => {
            // bento spans
            const spans = [
              "md:col-span-3 md:row-span-2 h-[460px] md:h-[560px]",
              "md:col-span-3 h-[280px]",
              "md:col-span-3 h-[280px]",
              "md:col-span-2 h-[280px]",
              "md:col-span-2 h-[280px]",
              "md:col-span-2 h-[280px]",
            ];
            return (
              <article
                key={idx}
                data-testid={`plato-card-${idx}`}
                className={`group relative overflow-hidden ${spans[idx]}`}
              >
                <img
                  src={IMGS[idx]}
                  alt={dish.name}
                  className="absolute inset-0 w-full h-full object-cover transition-transform duration-700 group-hover:scale-110"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/85 via-black/30 to-transparent" />
                <div className="absolute bottom-0 left-0 right-0 p-6 md:p-8">
                  <div className="text-[#E8A87C] text-[0.65rem] tracking-[0.25em] uppercase mb-2">
                    {dish.tag}
                  </div>
                  <h3 className="font-serif-display text-2xl md:text-3xl text-white">
                    {dish.name}
                  </h3>
                </div>
              </article>
            );
          })}
        </div>
      </div>
    </section>
  );
}
